'use client';

import { MarketType } from '@velocity-exchange/sdk';
import useMarketMaxLeverage from 'src/hooks/useMarketMaxLeverages';
import PresetTag from 'src/components/Tags/PresetTag';

const MarketLeverageTag = ({
	marketType,
	marketIndex,
}: {
	marketType: MarketType;
	marketIndex: number;
}) => {
	const { maxLeverage } = useMarketMaxLeverage(marketType, marketIndex);

	if (!maxLeverage) {
		return null;
	}

	return (
		<div className="flex flex-row items-center gap-x-xs">
			<PresetTag preset="leverage">{maxLeverage}x</PresetTag>
		</div>
	);
};

export default MarketLeverageTag;
